 <template>
  <v-sheet>
    <v-list dense>
      <v-list-item v-for="(d, i) in toutesDemandes" :key="`${i}`">
        <v-list-item-content>
          <v-list-item-title>
            <template v-if="d.type">
              {{ d.type | typedocument }}
            </template>
            <template v-else> Demande de précisions </template>
          </v-list-item-title>

          <v-list-item-subtitle style="white-space: pre-wrap"
            >{{ d.precisions }}
          </v-list-item-subtitle>

          <v-row dense>
            <v-col v-for="doc in d.pieces" :key="doc.uuid" cols="12">
              <a-document-card
                :value="doc"
                @supprimer="supprimer(doc, d)"
                @telecharge="telecharge"
              />
            </v-col>
          </v-row>

          <div v-if="!d.valide" class="d-flex">
            <v-spacer />
            <v-btn data-testid="ajouter-document" text @click="ajouter(d)">
              <v-icon>mdi-plus-circle</v-icon>
              Ajouter
            </v-btn>
            <v-spacer />
          </div>
          <v-divider class="mt-2" />
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-sheet>
</template>

<script>
import makeRules from "@/mixins/makeRules";
import makeValueData from "@/mixins/makeValueData";

function mapTo(src, dest) {
  dest.observation = src.observation;
  dest.demandes = src.demandes;
  dest.etat = src.etat;
  dest.dateRetour = src.dateRetour;
}

export default {
  mixins: [makeValueData(mapTo), makeRules()],

  methods: {
    telecharge(document) {
      this.$emit("telecharge", document);
    },
    ajouter(piece) {
      this.$emit("ajouter", piece);
    },
    supprimer(document, piece) {
      this.$emit("supprimer", { document, piece });
    },
  },

  computed: {
    toutesDemandes() {
      return (this.value?.demandes || []).map(d => ({
        ...d,
        pieces: (d.pieces || []).map(p => ({
          ...p,
          actionsPossible: !d.valide,
        })),
      }));
    },
  },
};
</script>
